var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { API_LOAD_STATE } from 'globals/enums';
import { SET_TASK_LIST, SET_TASK_STATS, SET_TASK_FILTERS, RESET_TASK_FILTERS, RESET_TASK_MANAGEMENT, GET_TASK_LIST, SET_TASK_ERROR, SET_PAGE_NUMBER, SET_ASSIGNEE_USERS, SET_IS_CALL_ENTRY, } from './TaskManagement.actions';
var initialState = {
    loadingStatus: API_LOAD_STATE.NOT_LOADED,
    taskList: [],
    lastEvaluatedKey: null,
    count: 0,
    currentPage: 1,
    isCallEntry: false,
    stats: {
        open: 0,
        total: 0,
        inProgress: 0,
        completed: 0,
    },
    filters: {
        status: ['open'],
        priority: [],
        search: '',
        role: [],
        assigneeName: '',
        taskScope: '',
    },
    assigneeUsers: [],
};
var TaskManagementReducer = function (state, action) {
    var _a;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_TASK_LIST:
            return __assign(__assign({}, state), { loadingStatus: API_LOAD_STATE.PROGRESS });
        case SET_TASK_LIST:
            return __assign(__assign({}, state), { loadingStatus: API_LOAD_STATE.SUCCESSFUL, taskList: action.payload.data.map(function (task) { return (__assign(__assign({}, task), { id: task.task_id || task.localId })); }), lastEvaluatedKey: action.payload.lastEvaluatedKey });
        case SET_TASK_STATS:
            return __assign(__assign({}, state), { stats: action.payload });
        case SET_PAGE_NUMBER:
            return __assign(__assign({}, state), { currentPage: action.payload });
        case SET_TASK_FILTERS:
            return __assign(__assign({}, state), { filters: __assign(__assign({}, state.filters), (_a = {}, _a[action.payload.key] = action.payload.value, _a)) });
        case RESET_TASK_FILTERS:
            return __assign(__assign({}, state), { filters: action.payload });
        case SET_TASK_ERROR:
            return __assign(__assign({}, state), { loadingStatus: API_LOAD_STATE.ERROR });
        case SET_ASSIGNEE_USERS:
            return __assign(__assign({}, state), { assigneeUsers: action.payload });
        case SET_IS_CALL_ENTRY:
            return __assign(__assign({}, state), { isCallEntry: action.payload });
        case RESET_TASK_MANAGEMENT:
            return __assign(__assign({}, initialState), { isCallEntry: state.isCallEntry });
        default:
            return state;
    }
};
export default TaskManagementReducer;
